import React, { useEffect } from 'react'
import Image from 'next/image'
import { Row, Col, Divider } from 'antd'
import BrokerQuickLinks from 'components/comparebroker/CompareBrokerQuickLinks'
import QuickLinks from 'components/shared/QuickLinks'
import Comments from '../comments/Comments'
import ArticleCategories from './ArticleCategories'
import ArticleTags from './ArticleTags'
import TitleAndDescription from './TitleAndDescription'

const Adsense = () => (
  // FTAppRightSideVertical
  <ins
    className="adsbygoogle"
    style={{ display: 'block' }}
    data-ad-client="ca-pub-9791786401617970"
    data-ad-slot="6455735046"
    data-ad-format="auto"
    data-full-width-responsive="true"
  />
)

export default function ArticleContent({ articleData, articleList }) {
  const {
    attributes: { tags, broker, categories, country },
  } = articleData
  const related = 'api::article.article'
  const title = 'Related Discussions'
  const linkList = []

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      try {
        window.adsbygoogle = window.adsbygoogle || []
        window.adsbygoogle.push({})
      } catch (e) {
        console.error(e)
      }
    }
  }, [])

  if (articleList) {
    articleList.map((article) => {
      linkList.push({
        href: '/article/[slug]/',
        as: `/article/${article.slug}/`,
        linkText: ` ${article.title}`,
        textDescription: `${article.short_description}`,
      })
      return linkList
    })
  }
  return (
    <Row className="page-wrapper page" gutter={[16, 16]}>
      <Col xs={24} lg={18}>
        <Row>
          <Col span={24}>
            <TitleAndDescription articleData={articleData.attributes} />
            {process.env.NODE_ENV === 'production' && (
              <Row>
                <Col style={{ width: '100%', margin: '32px auto' }}>
                  <Adsense />
                </Col>
              </Row>
            )}

            <ArticleTags tags={tags} />
            <ArticleCategories categories={categories.data} />
            {country.data?.attributes?.name === 'India' && (
              <a target="_blank" href="https://bit.ly/2YUNebF" rel="noreferrer">
                <Image
                  width={728}
                  height={90}
                  alt=""
                  data-src="https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
                  src="https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
                />
              </a>
            )}
            <Divider style={{ color: '#1890ff' }}>Still got Doubts?</Divider>
            <Comments articleData={articleData} related={related} />
          </Col>
        </Row>
      </Col>
      <Col xs={24} lg={6}>
        <Row>
          <Col span={24}>
            {broker.data && <BrokerQuickLinks brokers={[broker.data]} />}
            <QuickLinks
              title={title}
              linkList={linkList}
              country={articleData.attributes.country.data.attributes.name}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

// ArticleContent.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,

//     title: PropTypes.string.isRequired,

//     description: PropTypes.string.isRequired,

//     broker: PropTypes.shape({
//       slug: PropTypes.string.isRequired,
//     }),

//     tags: PropTypes.arrayOf(PropTypes.string),
//   }).isRequired,

//   articleList: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,

//       title: PropTypes.string.isRequired,

//       description: PropTypes.string.isRequired,

//       broker: PropTypes.shape({
//         name: PropTypes.string.isRequired,

//         slug: PropTypes.string.isRequired,
//       }),

//       tags: PropTypes.arrayOf(PropTypes.string),
//     })
//   ).isRequired,
// }
